<script setup>
name: 'blogCategoriesBar'
const props = defineProps({
  activeSlug: {
    type: String,
    required: false
  }
})

const { getBlogSettings } = useBlogData()

const { data: settings, error: error } = await getBlogSettings()
let categories = settings.value.categories
</script>

<template>
  <section class="categories-wrapper">
    <div class="container-fluid">
      <div class="row categories-container">
        <a v-for="category in categories" :href="category.attributes.slug == activeSlug ? '/blog' : `/blog/categories/${category.attributes.slug}`" :slug="category.attributes.slug" class="col-auto flex-shrink- category" :class="category.attributes.slug == activeSlug ? ' active' : ''">{{ category.attributes.category }}<i class="icon-close" :class="category.attributes.slug == activeSlug ? ' d-inline' : ' d-none'"></i></a>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.categories-wrapper{
  background-color: $color-secondary;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.11);
  margin-bottom: 50px;
  .categories-container{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    overflow-x: scroll;

    &::-webkit-scrollbar {
      height: 5px;
    }

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    }

    &::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
    }

    .category{
      display: inline-block;
      border-radius: 16px;
      padding: 4px 16px;
      color: $color-primary;
      text-decoration: none;
      font-weight: 600;
      border: solid 1px $color-subtext;
      margin: 16px 5px;
      transition: 0.3s;
      white-space: nowrap;
      
      &:hover, &.active{
        background: $color-body-text;
        color: $color-secondary;
      }
      &.active{
        i{
          padding-left: 10px;
          color: $color-secondary;
          font-size: $font-size-small;
        }
      }
    }
  }
}
</style>